import { useState } from 'react';

import jwt_decode from "jwt-decode";


const getTokenInfo = () => {

  const tokenString = localStorage.getItem('token');
  //console.log(tokenString)
  if (tokenString !== null)
    return jwt_decode(JSON.parse(tokenString).token);
  else
    return null
};

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('token_site');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token_site', JSON.stringify(userToken));
    setToken(userToken.token);
  };

  return {
    setToken: saveToken,
    token,
    getTokenInfo
  }
}

export function usarToken() { 
  // antigo nome useToken
  // nao é valido pois estava a ser detetado como um hook
  

  const getToken = async () => {
    try {
      const tokenString = localStorage.getItem('@tokengr');
      return tokenString === null ? null : tokenString
    } catch (error) {
      console.log("ficheiro: useToken, funcao: getToken, error:", error)
    }
  };

  const saveToken = async (userToken, userData) => {
    try {
      if (userToken) {
        return localStorage.setItem('@tokengr', JSON.stringify(userToken))
      }
    } catch (error) {
      console.log("ficheiro: useToken, funcao: saveToken, error:", error)
    }
  }


 
  const logout = async () => {
    try {
      localStorage.clear()
      //console.log('localStorage.getIte); logout', localStorage.getItem('@tokengr'))
      return
    } catch (error) {
      console.log("ficheiro: useToken, funcao: logout, error:", error)
    }
  }

  return {
    getToken,
    saveToken,
    logout,
  }



}

export {
  getTokenInfo
}